export default "__VITE_ASSET__1c69ac64__"